import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import Lodinging from "../components_root/loading.jsx";
import Loadingimg from '../components_root/loadingimg.jsx';
import { googleLogout, checkUserAuth } from '../firebase.js';
//page links  
//import propertyVideo from "../assets/properties/properties.mp4";
import { IoIosArrowDown } from "react-icons/io";
import propertyVideo from "../assets/customer_signing_contract.mp4";
import './properties.css';
import ShareButton from '../components_root/ShareButton.jsx';
import Header from '../body_root/header.jsx';
import Footers from '../body_root/footer.jsx';
import Navbar from '../body_root/Navbar.jsx';
import Select_yes_no from '../components_root/select_yes_no.jsx';
import { Randomcode } from '../components_root/rendom_code.js';

import { MdAdd, MdBusinessCenter, MdFindInPage, MdLocationCity, MdLocationPin, MdManageAccounts, MdOutlineArrowDownward, MdRoom, MdSecurity, MdSell } from 'react-icons/md';
export const seo = {
  title: "Viabig Properties | Buy, Sell & Rent Homes in Mohali, Chandigarh & Tricity",
  description:
    "Viabig Properties offers end‑to‑end real estate services in Mohali, Chandigarh, Zirakpur & Tricity — buy, sell, rent, and property management with verified listings, transparent pricing, and swift paperwork.",
  keywords:
    "Viabig Properties, property dealers Mohali, flats for rent Mohali, flats for sale Mohali, buy home Mohali, real estate Tricity, property management Chandigarh, commercial space Mohali, rental services, RERA consultant",
  ogImage:
    "https://viabig.com/assets/og/viabig-properties.jpg", // update if needed
  url: "https://viabig.com/properties",
  author: "Viabig"
};
export default function Properties_root() {
  const navigate = useNavigate();
  const [stockscompanies, setStockscompanies] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("rent");
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("search");
        if (tab) setActiveTab(tab.toLowerCase());
    }, []);
    const setTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("search", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", "" + newUrl);
    };
  return (
    <div>
      <Header />
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:url" content={seo.url} />
        <meta name="twitter:image" content={seo.image} />
      </Helmet>

      <div className='container_roots'>
        <div className="banner_body">
          {/* <video autoPlay muted loop playsInline className="background_video">
            <source src={propertyVideo} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video> */}
          <div className="set-loc-div">
            <div className="banner-cont-body">
              
              <div className="banner-Headline text-shadow">
                Viabig Properties - Buy/ Sell/ Rent a Home
              </div>
{/* 
              <div className="banner-Tagline text-shadow">
                Verified new and resale flats, builder floors & plots with price discovery, site visits and loan support.
              </div> */}
              <br/>
              <div className='search_body shadow hover'>
                        <div className="tabs-body" style={{gap:'5px 1%'}}>
                                    <div
                                        className={`tabsbutton ${activeTab === "rent" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("rent"); setTabInUrl("rent"); }}
                                    >
                                        <a className="tabs-text text-h2 text-black">Rent</a>
                                    </div>
                                    <div
                                        className={`tabsbutton ${activeTab === "property" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("property"); setTabInUrl("property"); }}
                                    >
                                        <a className="tabs-text text-h2 text-black">Buy</a>
                                    </div>
                                   
                                    <div
                                        className={`tabsbutton ${activeTab === "commercial" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("commercial"); setTabInUrl("commercial"); }}
                                    >
                                        <a className="tabs-text text-h2 text-black">Commercial</a>
                                    </div>
                               
                                </div>
                                <div className='search-div hover'>
                                  <table>
                                    <tr>
                                      <td className='border-right' width={130}><div className='button-box fill sline'><a>Location </a><IoIosArrowDown className='icon' /></div></td>
                                      <td><input 
  className="sear-input" 
  placeholder={`Search ${activeTab}`} 
/></td>
                                    </tr>
                                  </table>
                                </div>
              </div>
              <br />
              <div className="ui-items button-ui p-33 primary-back shadow center">
                <MdLocationCity className="icon" />
                Mohali • Chandigarh • Tricity
              </div>

            </div>
          </div>
        </div>
        <br />

        <div className='container_size'>
          <div className="post-container p-1 rounded-lg">
            <div className='ui-grid-2item'>
              <div className="ui-items p-2 shadow hover center cursor" onClick={() => navigate('/rent')}>

                <table>
                  <tr>
                    <td width={30}> <MdLocationPin className="icon" /></td>
                    <td>
                      <div className="text-h2 bold"  >Rent Home</div>
                    </td>
                  </tr>
                </table>
              </div>
              <div onClick={() => navigate('/list-rent?uid='+Randomcode(18))} className="ui-items p-2 hover shadow center cursor" >

                <table>
                  <tr>
                    <td width={30}> <MdManageAccounts className="icon" /></td>
                    <td>
                      <div className="text-h2 bold"  >List Rent</div>
                    </td>
                  </tr>
                </table>

              </div>
              <div className="ui-items  p-2 shadow center cursor hover" onClick={() => navigate('/buy-property')}>
                <table>
                  <tr>
                    <td width={30}> <MdFindInPage className="icon" /></td>
                    <td>
                      <div className="text-h2 bold"  >Buy property</div>
                    </td>
                  </tr>
                </table>
              </div>
              <div className="ui-items p-2  shadow center cursor hover" onClick={() => navigate('/sell-property')}>
                <table>
                  <tr>
                    <td width={30}> <MdSell className="icon" /></td>
                    <td>
                      <div className="text-h2 bold"  >Sell property</div>
                    </td>
                  </tr>
                </table>

              </div>
            </div>
          </div>
          <br />
      <br />
          <div className="offers-loc-div">
            <div className="text-h1">Why choose Viabig Properties?</div>
            <br />
            <div className="ui-grid">
              <div className="ui-items items-back p-2 hover shadow">
                <div className="text-h3 fw-bold">Verified Listings</div>
                <div className="text-h3">We pre‑screen owners/builders and verify documents before you waste time on visits.</div>
              </div>
              <div className="ui-items items-back p-2 hover shadow">
                <div className="text-h2 fw-bold">Paperwork Done Right</div>
                <div className="text-h3">Token, agreement, sale deed, police verification & handover checklist — all managed.</div>
              </div>
              <div className="ui-items items-back p-2 hover shadow">
                <div className="text-h2 fw-bold">Faster Closures</div>
                <div className="text-h3">Smart shortlisting + scheduled visits help you decide and close sooner.</div>
              </div>
         

            </div>
          </div>


          {/* <div className='container_size'>
      
          <div>
            {loading ? (
              <Lodinging />
            ) : stockscompanies.length === 0 ? (
              <p>companies update</p>
            ) : (
              <div className="ui-grid">
                {stockscompanies.map((row, i) => (
                  <div
                    key={i}
                    className="ui-items items-back border"
                    style={{ padding: "10px 10px" }}
                  >
                    <table>
                      <tr> <td className="font-header bold">{row.symbol}</td>
                        <td width={130}>{<div className="font-details">
                          {row.date_time.toDate().toLocaleDateString()}{" "}
                          {row.date_time.toDate().toLocaleTimeString()}
                        </div>}</td>
                      </tr>
                    </table>
                    <table >
                      <tr><td width={40}>Open</td><td>Change</td><td>Volume</td><td>High</td><td>Low</td></tr>
                      <tr><td  >{row.ohlc.open}</td> <td
                        className={
                          row.netChange > 0
                            ? 'status-ui green-back bold'
                            : row.netChange < 0
                              ? 'status-ui red-back bold'
                              : ''
                        }
                      >
                        {row.netChange}
                      </td><td >{row.volume}</td><td className='green'>{row.ohlc.high}</td><td className='red'>{row.ohlc.low}</td>

                      </tr>

                    </table>


                  </div>
                ))}
              </div>
            )}
          </div>

        </div> */}
        </div>
      </div>
      <Footers />
      <Navbar />
    </div>
  );
}
